export enum SearchFieldMode {
	exact = 1,
	fts = 2,
	allFts = 3,
	matchPhrase = 4
}
